export const TrackConfig = new Map<string, any>([
  ["thumb", { icon: "icon-tupian", menus: ["visible", "delete"] }],
  ["video", { icon: "icon-shipin", menus: ["mute", "delete", "xx"] }],
  [
    "audio",
    {
      icon: "icon-yinxiao1",
      background: "#0953FD",
      menus: ["visible", "delete"],
    },
  ],
  [
    "text",
    {
      icon: "icon-wenben",
      background: "#C70A0A",
      menus: ["visible", "delete"],
    },
  ],
  ["image", {}],
  [
    "sticker",
    { icon: "icon-tiezhi", background: "#7215C4", menus: ["mute", "delete"] },
  ],
  [
    "effect",
    {
      icon: "icon-texiao",
      background: "#EB7402",
      menus: ["visible", "delete"],
    },
  ],
  [
    "background",
    {
      icon: "icon-beijing",
      background: "#7215C4",
      menus: ["mute", "visible", "delete"],
    },
  ],
  [
    "picInPic",
    {
      icon: "icon-huazhonghua",
      background: "#864343",
      menus: ["mute", "visible", "delete"],
    },
  ],
  ["filter", {}],
  ["transition", {}],
]);

// 位于主轨道上方的轨道，在分镜上方
export const trackDirectionUp = [
  "text",
  "image",
  "sticker",
  "picInPic",
  "effect",
  "thumb",
];

export const baseFps = 30;

/**
 * 单位帧时间，毫秒
 */
export const UnitFrame2ms = 1e3 / baseFps;
/**
 * 单位帧时间，微秒
 */
export const UnitFrame2μs = 1e6 / baseFps;

export const WaveOptions = {
  height: 28,
  width: "100%",
  splitChannels: false,
  normalize: true,
  waveColor: "#007bff",
  progressColor: "#dd5e98",
  cursorColor: "#ddd5e9",
  cursorWidth: 0,
  barWidth: 1,
  barGap: 1,
  barRadius: 1,
  barHeight: 0.6,
  barAlign: "bottom",
  minPxPerSec: 1,
  fillParent: true,
  mediaControls: true,
  autoplay: false,
  interact: false,
  dragToSeek: false,
  hideScrollbar: false,
  audioRate: 0.1,
  autoScroll: true,
  autoCenter: true,
  sampleRate: 8000,
} as const;
